import { ErrorBoundary, Notice, Shadow, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box, FlatList } from 'native-base';
import React from 'react';

import { useBatchTicketRequiredAttention } from '../../../../hooks';
import { flatListProps, noticeRequiredAttentionSection } from '../../../../utils';
import { ItemSeparator } from '../../../ItemSeparator';
import { RequiredAttentionItem } from '../RequiredAttentionItem';

interface RequiredAttentionProps {}

export const RequiredAttention: React.FC<RequiredAttentionProps> = () => {
  const { requiredAttentionData } = useBatchTicketRequiredAttention();
  return (
    <VStack space={Spacing['inline.xxxs']} py={{ base: Spacing['inline.xxxs'], sm: 0 }}>
      <Box pt={Spacing['inline.xxxs']}>
        <Notice
          textObjects={noticeRequiredAttentionSection}
          testId="notice"
          type="warning"
          backgroundColor={Utils.ColorToken.WithOpacity('feedback.attention.lightest', 0.4)}
        />
      </Box>
      <Shadow level={3}>
        {requiredAttentionData?.length === 0 && (
          <Box py={{ sm: Spacing['inline.md'] }}>
            <ErrorBoundary
              errorIconOrIllustration="NotEmptyIllustration"
              errorTitle="Nenhum item encontrado."
              errorMessage="Não existe nenhum item que seja requerido a sua atenção na lista."
            />
          </Box>
        )}
        <FlatList
          {...flatListProps}
          data={requiredAttentionData}
          keyExtractor={(item) => item?.basketCustomerOrderId}
          maxH="800px"
          flex={1}
          ItemSeparatorComponent={ItemSeparator}
          renderItem={({ item }) => <RequiredAttentionItem item={item} />}
        />
      </Shadow>
    </VStack>
  );
};
